import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import { ExperimentGroupVariations } from '../experiment/experiments';
import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';
import Global from '../../store/global-selectors';
import { Segment } from '../../services/analytics-services/segment';
import { useFeatureFlag } from '../../feature-flags/hooks/use-feature-flag';

const GROW_465 = 'GROW_465';

export const useTrackGrow465Experiment = () => {
  const isExperimentEnabled = useFeatureFlag(FeatureFlagDeclarations.enableGettingStartedGuideForExperiment);
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  const variant = isExperimentEnabled ? ExperimentGroupVariations.VARIANT : ExperimentGroupVariations.CONTROL;

  return useCallback(async () => {
    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_465,
      group_variation: variant,
      seller_id: sellerId,
      user_id: userId,
      enrollment_date: new Date(),
    });
  }, [sellerId, userId, variant]);
};
